<script lang="ts">
	import dark from 'stores/theme';
	import CurrencySelector from '../CurrencySelector/CurrencySelector.svelte';
	import userStore from 'stores/user';
	//import LocaleSelector from '../LocaleSelector/LocaleSelector.svelte';
	import UserProfile from 'assets/svg/userProfile.svg?component';
	import LightTheme from 'assets/svg/lightTheme.svg?component';
	import DarkTheme from 'assets/svg/darkTheme.svg?component';
	import Portfolio from 'assets/svg/portfolio.svg?component';
	import Star from 'assets/svg/star.svg?component';
	import Exchanges from 'assets/svg/exchanges.svg?component';
	import { _ } from 'utils/i18/i18n';
	import LocaleLink from 'components/LocaleLink/LocaleLink.svelte';
	import MorePagesDropdown from 'components/MorePagesDropdown/MorePagesDropdown.svelte';

	export let darkTheme = false;

	let Modal;
	let isModalActive = false;
	function toggleModal() {
		import('components/ModalAsyncSignInUpForgot/ModalAsyncSignInUpForgot.svelte').then(res => Modal = res.default)
		isModalActive = !isModalActive;
	}

	$: userEmail =
		$userStore?.email?.length > 10 ? `${$userStore?.email?.slice(0, 10)}...` : $userStore?.email;
</script>

<div class="nav-wrapper">
	<ul class="nav-list">
		<li class="nav-item">
			<LocaleLink href={`/exchanges`}>
				<span class="nav-link">
					<Exchanges width={14} height={14} class="link-icon" />
					<span class="link-text">{$_('navigation.exchanges')} </span>
				</span>
			</LocaleLink>
		</li>
		<li class="nav-item">
			<LocaleLink href="/watchlist" handler={(e) => {
				!$userStore.isLoggedIn && e.preventDefault();
			}}>
				<span
					class="nav-link"
					on:click={() => {
						!$userStore.isLoggedIn ? toggleModal() : null;
					}}
				>
					<Star width={14} height={14} class="link-icon" />
					<span class="link-text">{$_('navigation.watchlist')}</span>
				</span>
			</LocaleLink>
		</li>
		<li class="nav-item">
			<LocaleLink href="/portfolio" handler={(e) => {
				!$userStore.isLoggedIn && e.preventDefault();
			}}>
				<div
					class="nav-link"
					on:click={() => {
						!$userStore.isLoggedIn ? toggleModal() : null;
					}}
				>
					<Portfolio width={14} height={14} class="link-icon" />
					<span class="link-text">{$_('navigation.portfolio')}</span>
				</div>
			</LocaleLink>
		</li>
		<li class="nav-item"><MorePagesDropdown /></li>
	</ul>
	<ul class="mode-list">
		<li class="mode-list-item">
			<!-- <LocaleSelector dark={darkTheme} /> -->
		</li>
		<li class="mode-list-item"><CurrencySelector/></li>
		<li class="mode-list-item">
			{#if $userStore.isLoggedIn}
				<LocaleLink href="/account">
					<span class="nav-link">
						<UserProfile width={12} height={12} class="user-icon" />
						<span class="link-text login">{userEmail}</span>
					</span>
				</LocaleLink>
			{:else}
				<div
					class="nav-link"
					on:click={() => {
						toggleModal();
					}}
				>
					<UserProfile width={12} height={12} class="user-icon" />
					<span class="link-text login">{$_('navigation.signIn')}</span>
				</div>
			{/if}
		</li>
		<li
			class="mode-list-item"
			on:click={() => {
				dark.set(!$dark);
			}}
		>
			{#if darkTheme}
				<LightTheme width={16} height={18} class="theme-icon" />
			{:else}
				<DarkTheme width={20} height={20} class="theme-icon" />
			{/if}
		</li>
	</ul>
</div>

<svelte:component this="{Modal}" bind:active={isModalActive} {toggleModal} />

<style lang="scss">
	@import 'navigation';
</style>
